import { Switch } from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { SessionType } from "src/modules/interface";
import { IUser } from "src/modules/myAccount/types";
import { updateUserInfo } from "../facilityUser/api";
import { TeamMemberActions } from "./teamMemberReducer";
import { Dispatch } from "react";
import { handleApiError } from "src/utils/errors";
import { Modal } from "antd";
import { EMPLOYEE_ROLES } from "@src/appV2/Employee/constants";
import { showSuccessToast, showWarningToast } from "@src/appV2/lib/Notifications";

interface SuspiciousSwitchProps {
  member: IUser;
  dispatch: Dispatch<TeamMemberActions>;
}

export function SuspiciousSwitch(props: SuspiciousSwitchProps) {
  const { member, dispatch } = props;
  const {
    adminUserId,
    profile: { userId: workplaceId },
    adminProfile,
    admin,
  } = useSelector((state: SessionType) => state.session);
  const {
    mutateAsync: updateFacilityUserSuspiciousStatus,
    isLoading: isLoadingFacilityUserSuspiciousStatus,
  } = useMutation({
    mutationFn: updateUserInfo,
    onError: (error: Error) => handleApiError(error),
  });

  const canUpdateFacilityUserSuspiciousStatus =
    admin && adminProfile?.roles?.includes(EMPLOYEE_ROLES.MANAGE_FACILITY_USER_SUSPICIOUS_STATUS);

  async function onConfirm() {
    const updatedTeamMember: IUser = await updateFacilityUserSuspiciousStatus({
      facilityId: workplaceId,
      performedBy: adminUserId,
      userId: member._id,
      userInfo: {
        isSuspicious: !member.isSuspicious,
      },
    });

    if (updatedTeamMember) {
      dispatch({
        type: "SET_UPDATED_TEAM_MEMBER",
        member: updatedTeamMember,
      });
      if (updatedTeamMember.isSuspicious) {
        showWarningToast(`${member.email} marked as suspicious`);
      } else {
        showSuccessToast(`${member.email} marked as unsuspicious`);
      }
    }
  }
  return (
    <div>
      <Switch
        checked={member.isSuspicious}
        color="error"
        size="small"
        disabled={isLoadingFacilityUserSuspiciousStatus || !canUpdateFacilityUserSuspiciousStatus}
        aria-label="toggle suspicious"
        onChange={async () => {
          Modal.confirm({
            title: (
              <span>
                Mark <b>{member.email}</b> as {!member.isSuspicious ? "suspicious" : "unsuspicious"}
                ?
              </span>
            ),
            onOk: onConfirm,
            okText: !member.isSuspicious ? "Mark suspicious" : "Mark unsuspicious",
          });
        }}
      />
    </div>
  );
}
